import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useCreate from "../../useCreate";
import toast from "react-hot-toast";

const useDeleteAttributeValue = ({ onSuccess } = {}) => {
  const { attributeValueId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setDataToServer } = useCreate({
    url: "product/attribute-value/delete",
    onSuccess: (response, reqParams) => {
      toast.success("Attribute Value Deleted Successfully", {
        position: "top-right",
        duration: 3000,
      });
      // Call the callback after successful deletion
      onSuccess?.(reqParams);
    },
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit, setDataToServer };
};

export default useDeleteAttributeValue;
